import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ListConsumerWalletResponse } from './wallet.types';

const useListBackerConsumerWallet = <T = ListConsumerWalletResponse['wallet']>({
  expired = false,
  select,
}: {
  expired?: boolean;
  select?: (data: ListConsumerWalletResponse['wallet']) => T;
} = {}) => {
  const BackerApi = useBackerApi();

  const getWallet = async () => {
    const { data } = await BackerApi.get<ListConsumerWalletResponse>(
      `/consumer/wallet${expired ? '?expired=true' : ''}`
    );

    return data.wallet;
  };

  return useQuery({
    queryKey: [...backerKeys.consumerWallet.all, { expired }],
    queryFn: getWallet,
    select,
  });
};

export { useListBackerConsumerWallet };
